import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '../../theme/Theme.js';
import { Box } from '../../grid/Box/styled.js';
import { MoreHoriz } from '../../icons/MoreHoriz/MoreHoriz.js';
import { Root } from './styled.js';

const Menu = React.forwardRef((_a, ref) => {
    var { items } = _a, props = __rest(_a, ["items"]);
    const theme = useTheme();
    return (React.createElement(Root, Object.assign({ overflowedIndicator: React.createElement(Box, { "$display": 'flex', "$alignItems": 'center', "$gap": 4 },
            "\u0415\u0449\u0435",
            React.createElement(MoreHoriz, null)) }, props, { ref: ref, "$theme": theme, items: items })));
});
Menu.displayName = 'Menu';

export { Menu };
//# sourceMappingURL=Menu.js.map
